import React from "react";
import { Outlet } from "react-router-dom";

const Blood = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Blood;
